export function openPostWindow(url,arr){  //url要跳转到的页面，data要传递的数据，name显示方式（可能任意命名）
    var tempForm = document.createElement("form");  
    tempForm.id="tempForm1";  
    tempForm.method="post";  
    tempForm.action=url;  
    let list = [];
    list = arr;    
    tempForm.target=name;  
    if(null != list && list.length > 0){
        var hindeInputs = new Array(list.length);
        for(var i=0;i<list.length;i++){
            hindeInputs[i] = document.createElement("input");  
            hindeInputs[i].type="hidden";  
            hindeInputs[i].name= list[i].name;
            hindeInputs[i].value= list[i].value;
            tempForm.appendChild(hindeInputs[i]); 
        }
    }
    if (tempForm.attachEvent) {  // IE 
        tempForm.attachEvent("onsubmit",function(){ openWindow(name); });  
    } else if (tempForm.addEventListener) {  // DOM Level 2 standard  
            tempForm.addEventListener("onsubmit",function(){ openWindow(name); });  
    } 
    //tempForm.attachEvent("onsubmit",function(){ openWindow(name); });//必须用name不能只用url，否则无法传值到新页面
    document.body.appendChild(tempForm); 
    if (document.createEvent) { // DOM Level 2 standard  
        var evt = document.createEvent("MouseEvents");  
        evt.initMouseEvent("submit", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);  
        tempForm.dispatchEvent(evt);  
    } else if (tempForm.fireEvent) { // IE  
        tempForm.fireEvent('onsubmit');  
    }           
    // tempForm.fireEvent("onsubmit");
    tempForm.submit();
    document.body.removeChild(tempForm);
}

function openWindow(name)  {  
    var iWidth=1100; //弹出窗口的宽度;
    var iHeight=550; //弹出窗口的高度;
    var iTop = (window.screen.availHeight-30-iHeight)/2; //获得窗口的垂直位置;
    var iLeft = (window.screen.availWidth-10-iWidth)/2; //获得窗口的水平位置;        
    window.open('about:blank',name,"height="+iHeight+", width="+iWidth+", top="+iTop+", left="+iLeft+",toolbar=no, menubar=no,  scrollbars=yes,resizable=yes,location=no, status=no");  
}

export function openPostWindow2(url, params) {
    var newWin = window.open();
    var formStr = '';
    //设置样式为隐藏，打开新标签再跳转页面前，如果有可现实的表单选项，用户会看到表单内容数据
    formStr = '<form style="visibility:hidden;" method="POST" action="' + url + '"><input type="hidden" name="token" value="' + params + '" /></form>';

    newWin.document.body.innerHTML = formStr;
    newWin.document.forms[0].submit();   
    return newWin;
}


// WEBPACK FOOTER //
// ./src/assets/js/winopen.js